export default __webpack_public_path__ + "americanfootball-live.png";